// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const ProductMediaCardTheme: ThemeFile = {
  aw: {
    classes: {},
  },
  rba: {
    classes: {
      cardWrapper: 'flex flex-col border-b border-gray h-full',
      headlineWrapper: 'flex flex-col md:border-t md:border-black',
      headline: 'text-xs text-dark-gray font-sans font-medium md:mt-s',
      ratingsWrapper: 'flex items-center pt-xxs',
      ratingsIcons: 'flex mr-xxs',
      ratingsText: 'pr-xxs text-xs font-bold',
      totalProjectWrapper: 'flex flex-row text-left justify-bottom items-center',
      totalProjectCount: 'text-xxs text-black font-bold mr-xxxs lg:text-xs',
      totalProjectText: 'text-xxs font-regular font-serif lg:text-body',
      mediaWrapper: 'flex mt-s',
      thumbnailButtonWrapper: 'mt-xxs mb-xs flex flex-row flex-wrap items-center',
      thumbnailRowWrapper: 'h-[3.4375rem] flex flex-row',
      buttonContainer: 'flex flex-row',
      button:
        'group relative flex w-fit items-center border-2 border-theme-btn-secondary-border bg-theme-btn-secondary-bg p-[0.875rem] font-serif text-button font-bold text-theme-btn-secondary-text hover:bg-theme-btn-secondary-bg-hover hover:text-theme-btn-secondary-text-hover disabled:bg-gray disabled:border-gray disabled:text-dark-gray disabled:cursor-not-allowed',
      buttonIcon: 'text-primary group-hover:text-primary group-disabled:text-dark-gray pr-2',
      copyWrapper: 'flex grow flex-col text-left',
      body: 'text-theme-body text-body font-regular mb-s',
      subheadline: 'text-dark-gray',
      cta1: 'justify-center mb-m',
    },
  },
};
